<template>
  <div class="layout-default-wrapper">
    <div class="layout-default-header">
      <app-header />
    </div>
    <div class="layout-default-content-wrapper">
      <app-menu />
      <div class="layout-default-content">
        <div class="layout-default-content-container">
          <nuxt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/App/Header";
import AppMenu from "@/components/App/Menu";

export default {
  components: {
    AppHeader,
    AppMenu
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/index.scss";
@import "@/assets/scss/materialdesignicons/materialdesignicons.scss";
</style>



// WEBPACK FOOTER //
// resources/nuxt/layouts/office.vue